const LOCALE_ARRAY = [
  { name: 'English', code: 'en' },
  { name: 'Français', code: 'fr' },
  { name: 'Italiano', code: 'it' },
  { name: 'Deutsch', code: 'de' },
  { name: 'Español', code: 'es' },
  { name: 'Nederlands', code: 'nl' },
];

export default LOCALE_ARRAY;
